import axiosInstance from 'services/axios';
import { ADD_MEASUREMENT_API_URL } from './AddMeasurement.constant';
import downloadAxiosInstance from 'services/downloafAxios';
import { downloadFile } from 'commons/utils';

export const uploadScreenList = (data, params) => {
  return axiosInstance
    .post(ADD_MEASUREMENT_API_URL.UPLOAD_SCREEN_LIST, data, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const validateScreenList = (data, params) => {
  return axiosInstance
    .post(ADD_MEASUREMENT_API_URL.VALIDATE_SCREEN_LIST, data, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const getScreenList = (params) => {
  return axiosInstance
    .get(ADD_MEASUREMENT_API_URL.GET_SCREEN_LIST, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const getMissingScreenList = (params) => {
  return axiosInstance
    .get(ADD_MEASUREMENT_API_URL.GET_MISSING_SCREEN_LIST, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const downloadMissingScreenList = (params) => {
  return downloadAxiosInstance
    .get(ADD_MEASUREMENT_API_URL.DOWNLOAD_MISSING_SCREEN_LIST, { params })
    .then((response) => {
      downloadFile(response.data, 'missing_screens.csv');
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};
